// import { URLS } from './api';

export const QUERY_KEYS = {
	cookiesConsent: (args?: Record<string, unknown>) => ['cookiesConsent', args],
	featureFlags: () => ['featureFlags'],
	myProfile: (args?: Record<string, unknown>) => ['my-profile', args],
	myContractSupportRequestCreate: (args?: Record<string, unknown>) => [
		'myContractSupportRequestCreate',
		args,
	],
	partners: (args?: Record<string, unknown>) => ['partners', args],
	partnersCategories: (args?: Record<string, unknown>) => ['partnersCategories', args],
	customerRequestCreate: (args?: Record<string, unknown>) => ['customerRequestCreate', args],
	customerRequestConfirmCreate: (args?: Record<string, unknown>) => [
		'customerRequestConfirmCreate',
		args,
	],
	publicRewards: () => ['publicRewards'],
	publicInstallments: (args?: Record<string, unknown>) => ['combinedInstallments', args],
	publicUpsellServicesPriceCalculator: (args?: Record<string, unknown>) => [
		'publicUpsellServicesPriceCalculator',
		args,
	],
	exchangeRates: (args?: string) => ['exchangeRates', args],
	ecbExchangeRateMarkups: (args?: string) => ['ecbExchangeRateMarkups', args],
	questionnaire: (args?: Record<string, unknown>) => ['questionnaire', args],
	remoteTranslations: (args?: Record<string, unknown>) => ['remoteTranslations', args],
	couponsList: (params?: Record<string, unknown>, args?: Record<string, unknown>) => [
		'couponsList',
		params,
		args,
	],
	couponDetail: (params?: Record<string, unknown>, args?: Record<string, unknown>) => [
		'couponDetail',
		params,
		args,
	],
	gcssData: () => ['gcssData'],
	gcssProductList: (params?: Record<string, unknown>) => ['gcssProductList', params],
	gcssBrands: (args?: Record<string, unknown>) => ['gcssBrands', args],
	gcssMerchants: (args?: Record<string, unknown>) => ['gcssMerchants', args],
	appstoreRedirect: (args?: Record<string, unknown>) => ['appstoreRedirect', args],
	ourPartners: (lang: string) => ['ourPartners', lang],
};
